import React from 'react'
import CalendarBox from '../../components/calendar/CalendarBox'
import EventsBox from '../../components/events/EventsBox'
import JobDescriptionBox from '../../components/job-description/job-description-box/JobDescriptionBox'
import NewsBox from '../../components/news/NewsBox'
import './home.scss'
import AppSection from '../../component/layout/AppSection'
import AppSimpleGrid from '../../component/layout/AppSimpleGrid'
import { Divider, Grid, Group, ScrollArea, Stack } from '@mantine/core'
import AppContainer from '../../component/layout/AppContainer'

const Home = () => {
  return (
    <AppSection>
      <AppSimpleGrid cols={1}>
        <Grid w="100%" h="100%" columns={3}>
          <Grid.Col span={2} h="100%">
            <Stack h="100%">
              <NewsBox />
              <Group w="100%" h="100%">
                <Grid w="100%" h="100%" columns={2}>
                  <Grid.Col span={1}>
                    <JobDescriptionBox />
                  </Grid.Col>
                  <Grid.Col span={1}>
                    <AppContainer h="100%">...</AppContainer>
                  </Grid.Col>
                </Grid>
              </Group>
            </Stack>
          </Grid.Col>
          <Grid.Col span={1}>
            <Stack h="100%">
              <CalendarBox />
              <EventsBox />
            </Stack>
          </Grid.Col>
        </Grid>
      </AppSimpleGrid>
    </AppSection>
  )
}
export default Home

// {/* <div className='wrapperHome'>
//     <div className='news'>
//         <NewsBox/>
//     </div>

//     <div className='calendarEvent boxContainer'>
//         <CalendarBox />
//         <hr className="separator"/>
//         <EventsBox />
//     </div>

//     <div className='job '>
//         <JobDescriptionBox/>
//     </div>

//     <div className='no-data boxContainer'>
//         no data
//     </div>

//     {/*<WeatherBox />*/}

//     </div> */}
